import React, { createContext, useContext, useState, useCallback } from 'react';
import * as pathsService from '../services/pathsService';

const PathsContext = createContext(null);

export function PathsProvider({ children }) {
  const [paths, setPaths] = useState(() => pathsService.getPaths());

  const refresh = useCallback(() => setPaths(pathsService.getPaths()), []);

  const create = useCallback((data) => {
    const p = pathsService.createPath(data);
    refresh();
    return p;
  }, [refresh]);

  const remove = useCallback((id) => {
    pathsService.deletePath(id);
    refresh();
  }, [refresh]);

  const update = useCallback((id, changes) => {
    pathsService.updatePath(id, changes);
    refresh();
  }, [refresh]);

  const addModule = useCallback((pathId, module) => {
    pathsService.addModuleToPath(pathId, module);
    refresh();
  }, [refresh]);

  const removeModule = useCallback((pathId, moduleUid) => {
    pathsService.removeModuleFromPath(pathId, moduleUid);
    refresh();
  }, [refresh]);

  return (
    <PathsContext.Provider value={{ paths, create, remove, update, addModule, removeModule, refresh }}>
      {children}
    </PathsContext.Provider>
  );
}

export const usePaths = () => {
  const ctx = useContext(PathsContext);
  if (!ctx) throw new Error('usePaths must be inside PathsProvider');
  return ctx;
};
